import { jsx as n } from "react/jsx-runtime";
import { s } from "../../../Table.module-Bb7fJIr8.js";
import { useTable as l } from "../hooks/useTable.js";
const u = ({ children: r }) => {
  const t = l(), o = t == null ? void 0 : t.api.getSortedRowModel().rows;
  if (o != null && o.length || !r) return null;
  const e = t == null ? void 0 : t.api.getVisibleFlatColumns().length;
  return e ? /* @__PURE__ */ n("tr", { children: /* @__PURE__ */ n("td", { className: s.empty, colSpan: e, children: r }) }) : null;
};
export {
  u as TableEmpty
};
